import { renderSkillFlywheelSummary } from '../../../src/lib/ui/skill-flywheel';
import { renderAnalytics } from './skill-analytics-renderers';
import { skillDetailData } from './skill-detail-data';
import { renderRelatedIssuesSection } from './skill-related-issues-renderers';

/**
 * Skill detail module facade.
 *
 * Keep the browser globals stable while implementation lives in focused data,
 * related-issue, and analytics modules.
 */

if (typeof window !== 'undefined') {
  window.SkillDetailData = skillDetailData;
  window.SkillDetailRenderers = { renderRelatedIssuesSection };
  window.SkillAnalyticsRenderers = {
    renderAnalytics,
    renderFlywheelSummary: (summary) => renderSkillFlywheelSummary(summary),
  };
}

export { renderAnalytics, renderRelatedIssuesSection, renderSkillFlywheelSummary };
